import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { internalProcClassification } from "../../../../../../../services/internalProcClassification.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const InternalProcedureClassification = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(internalProcClassification);

  const [
    internalProcedureClassifications,
    setInternalProcedureClassifications,
  ] = useState<ISelectType[]>([]);

  const fetchInternalProcClassification = useCallback(async () => {
    const { data, success } = await sendRequest(null);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifier.toString(),
        name: item.name,
      }));

      setInternalProcedureClassifications(newData);
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchInternalProcClassification();
  }, [fetchInternalProcClassification]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={internalProcedureClassifications}
        name="uBusIntegrationRuleMovIProcedClasses"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "internal_proc_classification")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
